import CardProfile from './CardProfile';

export default CardProfile;